import React, { useState, useRef } from "react";
import { Formik } from "formik";
import ErrorWrapper from "./ErrorWrapper";

import { Container, Row, Col, Form, Button } from "react-bootstrap";

const LinkRPHStoreForm = ({ RPHStoreInfo, CloseModal, ReloadStores, Stores }) => {
  const formRef = useRef();

  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);

    let storeInfo = {
      StoreId: values.storeId,
      RPHStoreId: RPHStoreInfo.rphStoreId,
    };

    fetch("IEEService/LinkStoreToRPHID", {
      mode: "cors",
      method: "POST",
      credentials: "include",
      body: JSON.stringify(storeInfo),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((data) => {
        setSubmitting(false);
        if (CloseModal) CloseModal();
        formRef.current.resetForm();
        ReloadStores();
        return data.json();
      })
      .catch(() => {
        setShowError(true);
        setErrorMessage("An error occurred trying to delete a store.");
      });
  };

  return (
    <Container fluid="md">
      <Row>
        Store name from RPH: {RPHStoreInfo.storeName}, RPH ID: {RPHStoreInfo.rphStoreId}
        <ErrorWrapper ShowError={showError} Message={errorMessage} />
        <Formik
          initialValues={{
            storeId: 0,
          }}
          onSubmit={handleSubmit}
          innerRef={formRef}
          enableReinitialize
        >
          {({ values, handleChange, handleBlur, handleSubmit, isSubmitting, errors, touched }) => (
            <Form onSubmit={handleSubmit}>
              <Row className="mb-2">
                <Col>
                  <Form.Label>Store</Form.Label> {errors.storeId && touched.storeId ? <span className="danger">{errors.storeId}</span> : null}
                  <Form.Select name="storeId" onChange={handleChange} onBlur={handleBlur} value={values.storeId}>
                    <option value={0} key="0">
                      --Select Store--
                    </option>
                    {Stores.map((s) => (
                      <option value={s.storeInfo.id} key={s.storeInfo.id}>
                        {s.storeInfo.storename}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
              <Row>
                <Col className="d-grid gap-2">
                  <Button variant="success" disabled={isSubmitting} onClick={!isSubmitting ? handleSubmit : null} type="submit">
                    {" "}
                    {isSubmitting ? "Saving..." : "Save"}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Row>
    </Container>
  );
};

export default LinkRPHStoreForm;
